import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProductGrid from '../../common/ListingPage/ProductGridDesktop';
import ProductListContainer from '../../common/ListingPage/ProductListingContainer';
import Layout from '../Layout';
import NotFound from '../../common/NotFound';
import Error503 from '../../common/Error503';
import BreadCrumb from '../../common/BreadCrumb';
import ProductQuickview from '../../common/ListingPage/quickview/ProductQuickview';
import Loader from '../../common/Loader.js';
import properties from '../../../modules/ajio-util/properties';
import SocialSharing from '../../common/CapsulePage/SocialSharing';
import CpImage from '../../common/CapsulePage/CpImage';

class CpPage extends React.Component {
  constructor(props) {
    super(props);
  }

  onActionClick = e => {
    const capsuleProducts = document.getElementById('capsule-products');
    const capsuleOffsetTop = capsuleProducts.offsetTop - 100;
    const element = document.body;
    const duration = 500;
    if (duration <= 0) return;
    const difference = capsuleOffsetTop - element.scrollTop;
    const perTick = (difference / duration) * 30;

    setTimeout(function() {
      element.scrollTop += perTick;
      if (element.scrollTop === capsuleOffsetTop) return;
      scrollTo(element, capsuleOffsetTop, duration - 10);
    }, 10);
  };

  render() {
    const {
      rilfnlBreadCrumb = [],
      productsAdditionalInfo = {},
      totalResults,
      pathname
    } = this.props;
    const page = this.props.match.params.cid;
    const { title = '', imageURL = '' } = productsAdditionalInfo;

    let cpPageSocialShare = true;

    if (!title && !imageURL) {
      return (
        <Layout>
          <div className="main-view-fluid">
            <NotFound mobile={false} />
          </div>
        </Layout>
      );
    }

    return (
      <Layout>
        <ProductListContainer apiPath="/api/capsulecp">
          {props => {
            const {
              searchInput,
              location,
              loadMoreItems,
              pushToHistory,
              replaceInHistory,
              isRequestOrginIsBrowser,
              hasErrored,
              errorDetails,
              categoryDescription
            } = props;
            if (
              !isRequestOrginIsBrowser &&
              hasErrored &&
              errorDetails &&
              (errorDetails.status === 400 || errorDetails.status === 504)
            ) {
              return (
                <div className="main-view main-view-fluid page page--mobile page--category">
                  <NotFound mobile />
                </div>
              );
            }
            if (
              !isRequestOrginIsBrowser &&
              hasErrored &&
              errorDetails &&
              errorDetails.status === 503
            ) {
              return (
                <div className="error-page">
                  <Error503 name="plp" />;
                </div>
              );
            }
            return (
              <div className="main-view page page--category-desktop product-view capsules">
                <div>
                  {rilfnlBreadCrumb.length > 0 ? (
                    <BreadCrumb breadcrumb={rilfnlBreadCrumb} />
                  ) : null}
                  <div className="plp-view">
                    <div className="capsule-container">
                      <CpImage
                        productsAdditionalInfo={productsAdditionalInfo}
                        onClick={this.onActionClick}
                      />
                      <div className="cp-common">
                        <SocialSharing
                          productsAdditionalInfo={productsAdditionalInfo}
                          cpPageSocialShare={cpPageSocialShare}
                        />
                        <div className="shopnow">
                          <span className="icon-text">SHOP NOW</span>
                          <div className="sprite-icon shopnow-ic" onClick={this.onActionClick} />
                        </div>
                      </div>
                    </div>
                    <Loader name="quick-view-loader" />
                    <div className="products" id="capsule-products">
                      <ProductGrid searchInput={searchInput} location={location} />
                    </div>
                    <ProductQuickview />
                  </div>
                </div>
              </div>
            );
          }}
        </ProductListContainer>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const { productsAdditionalInfo = {}, request = {} } = state;
  const { rilfnlBreadCrumbList = {} } = productsAdditionalInfo;
  const { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
  const { totalResults, pathname } = request;
  return {
    rilfnlBreadCrumb,
    productsAdditionalInfo,
    totalResults,
    pathname
  };
};

export default connect(mapStateToProps)(CpPage);
